const API_RESULT_STATUS = {
  SUCCESS: 1,
  FAIL_WITH_ERRORLIST: 2,
  FAIL: 3
}

export default {
  API_RESULT_STATUS
}
